import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { createShippingMethod } from "../../api/apiShipping";
import parseError from "../../utils/parseError";

export const useCreateShippingMethod = () => {
    const queryClient = useQueryClient();

    const { mutate: createShippingMethodMutate, isPending: isCreating } = useMutation({
        mutationFn: createShippingMethod,
        onSuccess: (res) => {
            toast.success(res.message || "Shipping method created successfully");
            queryClient.invalidateQueries(["shipping-methods"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to create shipping method");
        },
    });

    return { createShippingMethodMutate, isCreating };
};
